import { FC } from "react";
import favicon from "../../images/logos/favicon_virotrip-new.png";
import Cards, { Focused } from "react-credit-cards-2";
import "react-credit-cards-2/dist/es/styles-compiled.css";
import { Plan } from "containers/PageSubcription/type";

interface RenderSidebarProps {
  planDetails?: Plan;
  formik?: any;
  infoCardFocus: string;
}

const RenderSidebar: FC<RenderSidebarProps> = ({ planDetails, formik, infoCardFocus }) => {

  const presentDailyOnScreen = (
    planName: string | undefined,
    daily: number
  ) => {
    switch (planName) {
      case "ViroViajante":
        return `${new Intl.NumberFormat('pt-BR').format(daily)} ViroCash por ano`;
      case "ViroTurista":
        return `${new Intl.NumberFormat('pt-BR').format(daily)} ViroCash por ano`;
      case "ViroAventura":
        return `${new Intl.NumberFormat('pt-BR').format(daily)} ViroCash por ano`;
      case "ViroMemória":
        return `${new Intl.NumberFormat('pt-BR').format(daily)} ViroCash por ano`;
      case "ViroPatrão":
        return `${new Intl.NumberFormat('pt-BR').format(daily)} ViroCash por ano`;
    }
  };

  return (
    <div className="w-full flex flex-col sm:rounded-2xl lg:border border-neutral-200 dark:border-neutral-700 space-y-6 sm:space-y-8 px-0 sm:p-6 xl:p-8">
      <div className="flex flex-col sm:flex-row sm:items-center">
        <div className="flex-shrink-0 w-full sm:w-40">
          <div className=" aspect-w-4 aspect-h-3 sm:aspect-h-4 rounded-2xl overflow-hidden">
            <img
              alt=""
              className="absolute inset-0 object-cover"
              sizes="200px"
              src={favicon}
            />
          </div>
        </div>
        <div className="py-5 sm:px-5 space-y-3">
          <div>
            <span className="text-base whitespace-nowrap font-medium mt-1 block">
              {`Nome do plano: ${planDetails?.name}`}
            </span>
          </div>
          <span className="block text-sm whitespace-nowrap text-neutral-500 dark:text-neutral-400">
            Quantidade:{" "}
            {planDetails?.points && presentDailyOnScreen(
              planDetails?.name,
              planDetails?.points
            )}
          </span>
          <div className="w-10 border-b border-neutral-200  dark:border-neutral-700"></div>
        </div>
      </div>
      <div className="flex flex-col space-y-4">
        <h3 className="text-2xl font-semibold">Detalhes do Preço</h3>
        <div className="flex justify-between text-neutral-6000 dark:text-neutral-300">
          <span>Assinatura anual com parcelas de:</span>
          <span>{`${Intl.NumberFormat("pt-BR", {
            style: "currency",
            currency: "BRL",
          }).format(planDetails?.monthly_value ?? 0)}`}</span>
        </div>
        <div className="border-b border-neutral-200 dark:border-neutral-700"></div>
        <div className="flex justify-between font-semibold">
          <span>Total</span>
          <span>{`${Intl.NumberFormat("pt-BR", {
            style: "currency",
            currency: "BRL",
          }).format(planDetails?.monthly_value ?? 0)}`}</span>
        </div>
      </div>
      <div className="flex flex-col space-y-4">
        <Cards
          cvc={formik.values.cvc}
          expiry={formik.values.expiry}
          focused={infoCardFocus as Focused}
          name={formik.values.name}
          number={formik.values.number}
          locale={{ valid: "valido até" }}
          preview={true}
          placeholders={{ name: "NOME DO TITULAR" }}
        />
      </div>
    </div>
  );
}

export default RenderSidebar